import { useState } from 'react';
import {
 Popover, PopoverButton, PopoverPanel, Transition,
} from '@headlessui/react';
import { usePopper } from 'react-popper';
import Icon from '@/core/icon.js';
import { useTranslation } from '@/helpers/translate';

function SpaceIconPopover({ name, children }) {
  const { t } = useTranslation();
  const translationKey = name === 'hof2' ? 'hof' : name;
  const [open, setOpen] = useState(false);
  const [refLabel, setRefLabel] = useState();
  const [refPopover, setRefPopover] = useState();
  const hasCustomTrigger = !!children;

  const { styles, attributes } = usePopper(refLabel, refPopover);
  return (
    <Popover>
      <PopoverButton
        className={`${hasCustomTrigger ? '' : 'flex flex-row items-center text-sm text-left'}`}
        onMouseEnter={() => setOpen(true)}
        onMouseLeave={() => setOpen(false)}
        ref={setRefLabel}
      >
        {hasCustomTrigger ? children : <span className="ml-1"><Icon className="fill-current size-5 text-purple" name={name} /></span>}
      </PopoverButton>
      <Transition
        className="relative z-30"
        show={open}
        enter="transition duration-100 ease-out"
        enterFrom="transform scale-95 opacity-0"
        enterTo="transform scale-100 opacity-100"
        leave="transition duration-75 ease-out"
        leaveFrom="transform scale-100 opacity-100"
        leaveTo="transform scale-95 opacity-0"
      >
        <PopoverPanel
          static
          ref={setRefPopover}
          anchor="bottom start"
          className="flex flex-col px-4 py-3 my-2 mb-2 text-sm rounded-lg bg-purple-6 w-52 shadow-button text-dark"
          {...attributes.popper}
        >
          <div className="flex flex-col">
            <span className="text-sm font-medium leading-tight text-white">{t(`search:${translationKey}.title`)}</span>
            <span className="mt-1 text-xs leading-4 text-purple-1/50">{t(`search:${translationKey}.popover`)}</span>
          </div>
        </PopoverPanel>
      </Transition>
    </Popover>
  );
}
export default SpaceIconPopover;
